import React from 'react';
import { Paper } from "@material-ui/core"
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { IProfileForms } from "../types"
import ProfileForm from '../../profile/ProfileForm';
interface IGeneralForms {
  profileForms: IProfileForms[];
  onFormSubmit: (data: any) => Promise<any>;
  settings: any;
  formKey: string;
  isDisabled?: boolean;
  onFailedInteraction?: Function;
}

const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    leftButtonCustomClassName: {
      justifyContent: "unset!important",
      marginTop: "1.75rem",
      "& button": {
        width: "unset!important"
      }
    },
    rightButtonCustomClassName: {
      flexBasis: "0!important",
      display: "none!important"
    }
  }),
);

export function FormsContainer({ profileForms, onFormSubmit, settings, formKey, isDisabled, onFailedInteraction }: IGeneralForms) {
  const classes = useStyles();
  function mapForms() {
    return profileForms.map((mappedValue: IProfileForms, index: number) => {
      return <Paper style={{ padding: '2rem', marginBottom: '1.5625rem' }}>
        <ProfileForm 
          {...mappedValue} 
          formData={settings} 
          onFormSubmit={onFormSubmit} 
          key={`form-${formKey}-${index}`}
          rightButtonCustomClassName={classes.rightButtonCustomClassName}
          leftButtonCustomClassName={classes.leftButtonCustomClassName}
          isDisabled={isDisabled || mappedValue.disable}
          onFailedInteraction={onFailedInteraction}
        /></Paper>;
    });
  }
  return (
    <div>
      {mapForms()}
    </div>
  )
}
